export default __webpack_public_path__ + "static/media/mail-transparent-icon.ebe6389d.svg";